module.exports = function anonymous(it
) {
var out='<a class="js-report-link link" rel="localize[reports.buttons.'+(it.translation)+']" data-link-action="'+(it.translation)+'" ';if(it.fileName){ out+=' data-report-name='+(it.fileName)+' '; } out+=' >'+(it.text)+'</a>';return out;
}